import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';
import { Country } from '../country';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { Lead } from '../lead';
import { LeadSearchOptions } from '../lead-search-options';
import { LeadStatus } from '../lead-status';
import { LeadType } from '../lead-type';
import { LeadsFilterService } from '../service/leads-filter.service';
import { LoginService } from '../security/login.service';
import { SchoolListItem } from '../school-list-item';
import { UserService } from '../service/user.service';
import { LazyLoadEvent } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';


@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {

  leads: Lead[] = [];
  searchForm!: FormGroup;
  recordsByPage = 50;
  pageRecordsOptions = [50, 100, 500];
  totalRecords = 0;
  leadTypes: LeadType[] = [];
  schools: SchoolListItem[] = [];
  countries: Country[] = [];
  languages: Language[] = [];
  statuses: LeadStatus[] = [];
  loading = false;
  nameInput = null;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private loginService: LoginService,
    public leadsFilterService: LeadsFilterService,
    private userService: UserService
  ) {
    this.loginService.activatedNavigationComponent = true;
  }

  ngOnInit(): void {
    this.httpService.getLeadTypes().subscribe(res => {
      this.leadTypes = res;
    });
    this.httpService.getActiveSchools().subscribe(res => {
      this.schools = res;
    });
    this.httpService.getAllCountries().subscribe(res => {
      this.countries = res;
    });
    this.httpService.getLeadStatuses().subscribe(res => {
      this.statuses = res;
    });
    forkJoin({
      languages: this.httpService.getLanguages(),
      userInfo: this.httpService.getUserInfoByCookie()
    }).subscribe(({languages, userInfo}) => {
      this.languages = languages;
      let mainLanguage = userInfo.mainLanguage;
      if(!userInfo.hasDefaultLeadFilter){
        mainLanguage = null;
      }
      this.searchForm = this.builder.group({
        id: null,
        leadType: null,
        name: [null, Validators.minLength(3)],
        school: null,
        destination: null,
        email: [null, Validators.minLength(2)],
        language: mainLanguage,
        leadId: null,
        interestedIn: [null, Validators.minLength(2)]
      });
      this.doMultiFilterSearch(0);
    });
  }

  updateStringFilter(event: any){
    if(event.target.value == "" || event.target.value.length > 2){
      this.doMultiFilterSearch(0);
    }
  }

  updateNumberFilter(event: any){
    if(event.target.value == "" || event.target.value.length > 2){
      this.doMultiFilterSearch(0);
    }
  }

  doMultiFilterSearch(offset: number){
    console.log("multifilter called");
    let rows = this.recordsByPage;
    let options = new LeadSearchOptions(
      this.leadsFilterService.selectedDisplayOption, 
      this.searchForm.value.leadType,
      this.searchForm.value.name,
      this.searchForm.value.school,
      this.searchForm.value.destination,
      this.searchForm.value.email,
      this.searchForm.value.language,
      this.searchForm.value.leadId,
      this.searchForm.value.interestedIn
      );
      this.loading = true;
      this.httpService.getLeadsByMultiFilters(options, rows, offset).subscribe(res => {
        this.loading = false;
        this.leads = res.leads;
        this.totalRecords = res.recordNumber;
      });
  }

  lazyLoad(event: TableLazyLoadEvent) {
    this.doMultiFilterSearch(event.first!);
    window.scrollTo({top: 0, behavior: "smooth"});
  }

  resetSearchForm(){
    this.searchForm = this.builder.group({
      leadType: null,
      name: [null, Validators.minLength(3)],
      school: null,
      destination: null,
      email: [null, Validators.minLength(2)],
      language: null,
      leadId: null,
      interestedIn: [null, Validators.minLength(2)]
    });
    this.doMultiFilterSearch(0);
  }

  getStatusIdFromDisplayOption(){
    switch(this.leadsFilterService.selectedDisplayOption){
      case 2:
        return 1;
      case 3:
        return 2;
      case 4:
        return 3;
    }
    throw new Error("function getStatusIdFromDisplayOption is called when selectedDisplayOption is invalid value");
  }

}